<template>
  <div class="sm-unsubscribe-customer">
    <h4>Unsubscribe {{item.full_name || `${item.first_name} ${item.last_name}`}}?</h4>
    <radiobutton-block
      :text="`Cancel Subscription Immediately`" 
      :name="'unsubscribe'" 
      :checked="!setEndOfPeriod"
      @input="setEndOfPeriod = false"
    />
    <radiobutton-block
      :text="`Cancel Subscription at End of Period`" 
      :name="'unsubscribe'" 
      :checked="setEndOfPeriod"
      @input="setEndOfPeriod = true"
    />
    <div class="sm-unsubscribe-customer-flex">
      <btn-block
        :class="'sm-btn--small sm-btn--grey'"
        :text="'Cancel'"
        @click="$emit('cancel')"
      />
      <btn-block
        :type="'small'"
        :text="'Unsubscribe'"
        :class="'sm-btn--error'"
        @click="confirmUnsubscribe"
      />
    </div>
  </div>
</template>

<script>
import Radiobutton from '@/components/Radiobutton';
import DatepickerWrap from '@/components/DatepickerWrap';

export default {
  name: 'unsubscribe-customer',
  components: {
    'radiobutton-block': Radiobutton,
    'datepicker-wrap': DatepickerWrap,
  },
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      setEndOfPeriod: false
    }
  },
  methods: {
    confirmUnsubscribe() {
      let sendData = {
        id: this.item.id
      };

      if (this.setEndOfPeriod)
        sendData.end_of_period = true;

      this.$emit('unsubscribe', sendData)
    }
  }
}
</script>

<style lang="scss">
  @use '@/assets/scss/general/mixins.scss' as *;
  @use '@/assets/scss/framework/scss-variables.scss' as *;
  @use '@/assets/scss/components/customers/_unsubscribe-customer.scss';
</style>
